<template>
  <div class="info">
    <div class="main">
      <div class="logo">
        <img
          src="http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/logo.png"
        />
        <van-icon
          class="nav_btn"
          name="wap-nav"
          color="#fff"
          size=".5rem"
          @click="navShow = true"
        />
      </div>
      <div style="height: 1rem;"></div>
      <div class="project_m">
        <div class="mode_project">
          <div
            class="mode"
            v-for="(item, index) in datainfo.child"
            :key="index"
          >
            <div class="name">
              <img class="pro_ico" :src="item.ico" />
              <span>{{ item.title }}</span>
            </div>
            <!-- 第一种模式 -->
            <div
              v-if="urlId != 2 && urlId != 17"
              class="item_view"
              v-for="(item1, index1) in item.cont"
              :key="index1"
              @click="chooseAck(item1, item, '', index1, index, '')"
            >
              <div class="childName">{{ item1.name }}</div>
              <div class="textHtml" v-html="item1.text"></div>
              <img
                class="checkedImg"
                :src="
                  item1.checked
                    ? 'https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_wx2.png'
                    : 'https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_wx1.png'
                "
              />
            </div>
            <!-- 第二种模式 -->
            <div
              v-if="urlId == 2 || urlId == 17"
              class="item_view2"
              v-for="(item1, index1) in item.xilie"
              :key="index1"
            >
              <div class="xielieC">
                <div class="xlTitle">{{ item1.name }}</div>
                <div class="xlli">
                  <div
                    class="xl_li"
                    v-for="(item2, index2) in item1.cont"
                    :key="index2"
                    @click="
                      chooseAck(item2, item, item1, index2, index, index1)
                    "
                  >
                    <div class="childName">{{ item2.name }}</div>
                    <div class="textHtml" v-html="item2.text"></div>
                    <img
                      class="checkedImg"
                      :src="
                        item2.checked
                          ? 'https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_wx2.png'
                          : 'https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_wx1.png'
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <van-icon
      class="submit_btn"
      name="add"
      @click="goallSub"
      color="#fff"
      size=".8rem"
    /> -->
    <div class="submit_btn" @click="goallSub">
      <img
        src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_subbtn.png"
        width="100%"
      />
    </div>
    <div style="height: 1.6rem;"></div>
    <!-- 提交面诊信息 -->
    <div class="dialog_mz" v-if="subInfoDialog">
      <div class="mianzheng_main">
        <div class="mz_Title">提交面诊信息</div>
        <img
          src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_close.png"
          class="closeBtn"
          @click="hideSubDialog"
        />
        <div class="inputText">
          <span>用户姓名：</span
          ><input placeholder="请输入姓名" v-model="userName" />
        </div>
        <div class="inputText">
          <span>用户性别：</span>
          <div class="sex">
            <input
              type="radio"
              id="one"
              value="2"
              :class="pickedSex == 2 ? 'checkedInput' : 'checkInput'"
              v-model="pickedSex"
            />
            <label for="one">女</label>
            <input
              type="radio"
              id="two"
              value="1"
              :class="pickedSex == 1 ? 'checkedInput' : 'checkInput'"
              v-model="pickedSex"
            />
            <label for="two">男</label>
          </div>
        </div>
        <div class="inputText">
          <span>用户年龄：</span>
          <input placeholder="请输入年龄" v-model="userAge" />
        </div>
        <div class="inputText">
          <span>内 容：</span
          ><input
            v-model="userContent"
            class="contentInputText"
            disabled="disabled"
          />
        </div>
        <button class="yesSubinfo" @click="yesSubinfo">确定提交</button>
      </div>
    </div>
    <!-- 左侧菜单详情 -->
    <van-popup
      v-model="navShow"
      position="right"
      close-on-popstate
      closeable
      style="width: 50%;height:100%"
      class="nav_box"
    >
      <div class="nav_header">
        <img src="../../assets/img/nav_header.png" alt="" />
      </div>
      <div class="nav_content">
        <van-collapse v-model="activeNames" accordion>
          <van-collapse-item
            v-for="(item, index) in navList"
            :key="index"
            :title="item.title"
            :name="index"
          >
            <div
              class="title"
              v-for="(value, index) in item.child"
              :key="index"
            >
              <div
                :style="urlId == value.id ? 'color:#540186;' : ''"
                v-if="!value.child"
                @click="goPage(value.id)"
              >
                {{ value.title }}
              </div>
              <div
                v-for="(val, index) in value.child"
                :key="index"
                @click="goPage(val.id)"
                :style="urlId == val.id ? 'color:#540186;' : ''"
              >
                <span>{{ value.title }}</span> -- <span>{{ val.title }}</span>
              </div>
            </div>
            <div
              class="title"
              :style="urlId == item.id ? 'color:#540186;' : ''"
              v-if="!item.child"
              @click="goPage(item.id)"
            >
              <span>{{ item.title }}</span>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  Toast,
  Icon,
  Popup,
  Collapse,
  CollapseItem,
  Cell,
  CellGroup
} from "vant";
import { getShare, getAddConsultation } from "@api/public";
import { openShareAll } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import cookie from "@utils/store/cookie";
import { localStorage } from "@utils/store/localStorage";
let vm = null;
let SAVEDATA = "saveData";
export default {
  name: "mianzheng_info",
  components: {
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup
  },
  props: {},
  data: function() {
    return {
      urlId: "",
      logo:
        "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/logo.png",
      bgImg:
        "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/bgimg1.png",
      datainfo: "",
      subInfoDialog: false,
      userName: "",
      pickedSex: 2,
      userAge: "",
      userKey: "a28Xjl4VovNS59Du",
      userContent: "",
      subText: "",
      projectList: [
        {
          id: 0,
          project_name: "眼部护理",
          child: [
            {
              id: 18,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico0.png",
              title: "中胚层护理",
              cont: [
                {
                  id: 19,
                  name: "丝丽532",
                  text: "特价<span>1980</span>元",
                  content: "眼部护理-中胚层护理-丝丽532-特价1980元",
                  textAll: "丝丽532-特价1980元",
                  checked: false,
                  money: 1980
                },
                {
                  id: 20,
                  name: "三文鱼",
                  text: "特价<span>1980</span>元",
                  content: "眼部护理-中胚层护理-三文鱼-特价1980元",
                  textAll: "三文鱼-特价1980元",
                  checked: false,
                  money: 1980
                },
                {
                  id: 21,
                  name: "菲洛嘉",
                  text: "特价<span>2800</span>元",
                  content: "眼部护理-中胚层护理-菲洛嘉-特价2800元",
                  textAll: "菲洛嘉-特价2800元",
                  checked: false,
                  money: 2800
                },
                {
                  id: 22,
                  name: "氐珠",
                  text: "特价<span>3800</span>元",
                  content: "眼部护理-中胚层护理-氐珠-特价3800元",
                  textAll: "氐珠-特价3800元",
                  checked: false,
                  money: 3800
                }
              ]
            }
          ]
        },
        {
          id: 1,
          project_name: "眼部护理",
          child: [
            {
              id: 23,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico1.png",
              title: "仪器护理",
              cont: [
                {
                  id: 24,
                  name: "魔力紧肤（BTL）",
                  text: "特价<span>800</span>元",
                  content: "眼部护理-仪器护理-魔力紧肤（BTL）-特价800元",
                  textAll: "魔力紧肤（BTL）-特价800元",
                  checked: false,
                  money: 800
                },
                {
                  id: 25,
                  name: "眼部精华导入",
                  text: "特价<span>600</span>元",
                  content: "眼部护理-仪器护理-眼部精华导入-特价600元",
                  textAll: "眼部精华导入-特价600元",
                  checked: false,
                  money: 600
                }
              ]
            }
          ]
        },
        {
          id: 2,
          project_name: "眼部护理-居家护理",
          child: [
            {
              id: 26,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico12.png",
              title: "眼膜",
              xilie: [
                {
                  id: 27,
                  name: "华熙生物系列",
                  cont: [
                    {
                      id: 28,
                      name: "XXXXX",
                      text: "<span>00000</span>元",
                      content:
                        "眼部护理-居家护理-眼膜-华熙生物系列-xxxxx-00000元",
                      textAll: "华熙生物系列-xxxxx-00000元",
                      checked: false,
                      money: 0
                    }
                  ]
                },
                {
                  id: 29,
                  name: "修丽可系列",
                  cont: [
                    {
                      id: 30,
                      name: "XXXXX",
                      text: "<span>00000</span>元",
                      content:
                        "眼部护理-居家护理-眼膜-修丽可系列-xxxxx-00000元",
                      textAll: "修丽可系列-xxxxx-00000元",
                      checked: false,
                      money: 0
                    }
                  ]
                }
              ]
            },
            {
              id: 31,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico13.png",
              title: "眼霜",
              xilie: [
                {
                  id: 32,
                  name: "华熙生物系列",
                  cont: [
                    {
                      id: 33,
                      name: "米蓓尔",
                      text: "特价<span>00000</span>元",
                      content:
                        "眼部护理-居家护理-眼霜-华熙生物系列-米蓓尔-特价00000元",
                      textAll: "华熙生物系列-米蓓尔-00000元",
                      checked: false,
                      money: 0
                    },
                    {
                      id: 34,
                      name: "润百颜",
                      text: "特价<span>00000</span>元",
                      content:
                        "眼部护理-居家护理-眼霜-华熙生物系列-润百颜-特价00000元",
                      textAll: "华熙生物系列-润百颜-00000元",
                      checked: false,
                      money: 0
                    },
                    {
                      id: 35,
                      name: "夸迪",
                      text: "特价<span>00000</span>元",
                      content:
                        "眼部护理-居家护理-眼霜-华熙生物系列-夸迪-特价00000元",
                      textAll: "华熙生物系列-夸迪-00000元",
                      checked: false,
                      money: 0
                    }
                  ]
                }
              ]
            }
          ]
        },

        {
          id: 3,
          project_name: "上睑轻度",
          child: [
            {
              id: 36,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/ico1.png",
              title: "提眉",
              cont: [
                {
                  id: 37,
                  name: "一档",
                  text: "特价<span>4800</span>元",
                  content: "上睑轻度-提眉-一档-特价4800元",
                  textAll: "一档-特价4800元",
                  checked: false,
                  money: 4800
                },
                {
                  id: 38,
                  name: "二档",
                  text: "特价<span>6800</span>元",
                  content: "上睑轻度-提眉-二档-特价6800元",
                  textAll: "二档-特价6800元",
                  checked: false,
                  money: 6800
                },
                {
                  id: 39,
                  name: "三档",
                  text: "特价<span>8800</span>元",
                  content: "上睑轻度-提眉-三档-特价8800元",
                  textAll: "三档-特价8800元",
                  checked: false,
                  money: 8800
                }
              ]
            },
            {
              id: 40,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/ico1.png",
              title: "仪器",
              cont: [
                {
                  id: 41,
                  name: "魔力紧肤",
                  text: "特价<span>800</span>元",
                  content: "上睑轻度-仪器-魔力紧肤-特价800元",
                  textAll: "魔力紧肤-特价800元",
                  checked: false,
                  money: 800
                },
                {
                  id: 42,
                  name: "欧洲之星",
                  text: "特价<span>3800</span>元",
                  content: "上睑轻度-仪器-欧洲之星-特价3800元",
                  textAll: "欧洲之星-特价3800元",
                  checked: false,
                  money: 3800
                },
                {
                  id: 43,
                  name: "极速提拉",
                  text: "特价<span>7800</span>元",
                  content: "上睑轻度-仪器-极速提拉-特价7800元",
                  textAll: "极速提拉-特价7800元",
                  checked: false,
                  money: 7800
                },
                {
                  id: 44,
                  name: "热玛吉 四代",
                  text: "特价<span>12800</span>元",
                  content: "上睑轻度-仪器-极速热玛吉四代-特价12800元",
                  textAll: "极速热玛吉四代-特价12800元",
                  checked: false,
                  money: 12800
                }
              ]
            }
          ]
        },
        {
          id: 4,
          project_name: "上睑中度",
          child: [
            {
              id: 45,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico5.png",
              title: "提眉",
              cont: [
                {
                  id: 46,
                  name: "一档",
                  text: "特价<span>4800</span>元",
                  content: "上睑中度-提眉-一档-特价4800元",
                  textAll: "一档-特价4800元",
                  checked: false,
                  money: 4800
                },
                {
                  id: 47,
                  name: "二档",
                  text: "特价<span>6800</span>元",
                  content: "上睑中度-提眉-二档-特价6800元",
                  textAll: "二档-特价6800元",
                  checked: false,
                  money: 6800
                },
                {
                  id: 48,
                  name: "三档",
                  text: "特价<span>8800</span>元",
                  content: "上睑中度-提眉-三档-特价8800元",
                  textAll: "三档-特价8800元",
                  checked: false,
                  money: 8800
                }
              ]
            },
            {
              id: 49,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico6.png",
              title: "仪器",
              cont: [
                {
                  id: 50,
                  name: "魔力紧肤",
                  text: "特价<span>800</span>元",
                  content: "上睑中度-仪器-魔力紧肤-特价800元",
                  textAll: "魔力紧肤-特价800元",
                  checked: false,
                  money: 800
                },
                {
                  id: 51,
                  name: "欧洲之星",
                  text: "特价<span>3800</span>元",
                  content: "上睑中度-仪器-欧洲之星-特价3800元",
                  textAll: "欧洲之星-特价3800元",
                  checked: false,
                  money: 3800
                },
                {
                  id: 52,
                  name: "极速提拉",
                  text: "特价<span>7800</span>元",
                  content: "上睑中度-仪器-极速提拉-特价7800元",
                  textAll: "极速提拉-特价7800元",
                  checked: false,
                  money: 7800
                },
                {
                  id: 53,
                  name: "热玛吉 四代",
                  text: "特价<span>12800</span>元",
                  content: "上睑中度-仪器-极速热玛吉四代-特价12800元",
                  textAll: "极速热玛吉四代-特价12800元",
                  checked: false,
                  money: 12800
                }
              ]
            }
          ]
        },
        {
          id: 5,
          project_name: "上睑重度",
          child: [
            {
              id: 54,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico5.png",
              title: "提眉",
              cont: [
                {
                  id: 55,
                  name: "一档",
                  text: "特价<span>4800</span>元",
                  content: "上睑重度-提眉-一档-特价4800元",
                  textAll: "一档-特价4800元",
                  checked: false,
                  money: 4800
                },
                {
                  id: 56,
                  name: "二档",
                  text: "特价<span>6800</span>元",
                  content: "上睑重度-提眉-二档-特价6800元",
                  textAll: "二档-特价6800元",
                  checked: false,
                  money: 6800
                },
                {
                  id: 57,
                  name: "三档",
                  text: "特价<span>8800</span>元",
                  content: "上睑重度-提眉-三档-特价8800元",
                  textAll: "三档-特价8800元",
                  checked: false,
                  money: 8800
                }
              ]
            },
            {
              id: 58,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico3.png",
              title: "双眼皮重塑",
              cont: [
                {
                  id: 59,
                  name: "去皮/去脂",
                  text: "各<span>2000</span>元",
                  content: "上睑重度-双眼皮重塑-去皮/去脂-各2000元",
                  textAll: "去皮/去脂-各2000元",
                  checked: false,
                  money: 4000
                },
                {
                  id: 60,
                  name: "切开重睑",
                  text: "<span>2800</span>元",
                  content: "上睑重度-双眼皮重塑-切开重睑-2800元",
                  textAll: "切开重睑-2800元",
                  checked: false,
                  money: 2800
                },
                {
                  id: 61,
                  name: "内眦赘皮矫正",
                  text: "<span>3600-6000</span>元",
                  content: "上睑重度-双眼皮重塑-内眦赘皮矫正-3600-6000元",
                  textAll: "内眦赘皮矫正-3600-6000元",
                  checked: false,
                  money: 6000
                },
                {
                  id: 62,
                  name: "泪腺复位",
                  text: "<span>3800</span>元",
                  content: "上睑重度-双眼皮重塑-泪腺复位-3800元",
                  textAll: "泪腺复位-3800元",
                  checked: false,
                  money: 3800
                },
                {
                  id: 63,
                  name: "上睑下垂矫正",
                  text: "<span>4600-9800</span>元",
                  content: "上睑重度-双眼皮重塑-上睑下垂矫正-4600-9800元",
                  textAll: "上睑下垂矫正-4600-9800元",
                  checked: false,
                  money: 9800
                },
                {
                  id: 64,
                  name: "美化-翘睫",
                  text: "<span>2000</span>元",
                  content: "上睑重度-双眼皮重塑-美化-翘睫-2000元",
                  textAll: "美化-翘睫-2000元",
                  checked: false,
                  money: 2000
                },
                {
                  id: 65,
                  name: "美化-外眦开大",
                  text: "<span>4800</span>元",
                  content: "上睑重度-双眼皮重塑-美化-外眦开大-4800元",
                  textAll: "美化-外眦开大-4800元",
                  checked: false,
                  money: 4800
                },
                {
                  id: 66,
                  name: "美化-下睑下至",
                  text: "<span>4800</span>元",
                  content: "上睑重度-双眼皮重塑-美化-下睑下至-4800元",
                  textAll: "美化-下睑下至-4800元",
                  checked: false,
                  money: 4800
                }
              ]
            },
            {
              id: 67,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico6.png",
              title: "仪器",
              cont: [
                {
                  id: 68,
                  name: "魔力紧肤",
                  text: "特价<span>800</span>元",
                  content: "上睑重度-仪器-魔力紧肤-特价800元",
                  textAll: "魔力紧肤-特价800元",
                  checked: false,
                  money: 800
                },
                {
                  id: 69,
                  name: "欧洲之星",
                  text: "特价<span>3800</span>元",
                  content: "上睑重度-仪器-欧洲之星-特价3800元",
                  textAll: "欧洲之星-特价3800元",
                  checked: false,
                  money: 3800
                },
                {
                  id: 70,
                  name: "极速提拉",
                  text: "特价<span>7800</span>元",
                  content: "上睑重度-仪器-极速提拉-特价7800元",
                  textAll: "极速提拉-特价7800元",
                  checked: false,
                  money: 7800
                },
                {
                  id: 71,
                  name: "热玛吉 四代",
                  text: "特价<span>12800</span>元",
                  content: "上睑重度-仪器-极速热玛吉四代-特价12800元",
                  textAll: "极速热玛吉四代-特价12800元",
                  checked: false,
                  money: 12800
                }
              ]
            }
          ]
        },
        {
          id: 6,
          project_name: "上睑凹陷",
          child: [
            {
              id: 72,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico3.png",
              title: "双眼皮重塑",
              cont: [
                {
                  id: 73,
                  name: "去皮/去脂",
                  text: "各<span>2000</span>元",
                  content: "上睑凹陷-双眼皮重塑-去皮/去脂-各2000元",
                  textAll: "去皮/去脂-各2000元",
                  checked: false,
                  money: 4000
                },
                {
                  id: 74,
                  name: "切开重睑",
                  text: "<span>2800</span>元",
                  content: "上睑凹陷-双眼皮重塑-切开重睑-2800元",
                  textAll: "切开重睑-2800元",
                  checked: false,
                  money: 2800
                },
                {
                  id: 75,
                  name: "内眦赘皮矫正",
                  text: "<span>3600-6000</span>元",
                  content: "上睑凹陷-双眼皮重塑-内眦赘皮矫正-3600-6000元",
                  textAll: "内眦赘皮矫正-3600-6000元",
                  checked: false,
                  money: 6000
                },
                {
                  id: 76,
                  name: "泪腺复位",
                  text: "<span>3800</span>元",
                  content: "上睑凹陷-双眼皮重塑-泪腺复位-3800元",
                  textAll: "泪腺复位-3800元",
                  checked: false,
                  money: 3800
                },
                {
                  id: 77,
                  name: "上睑下垂矫正",
                  text: "<span>4600-9800</span>元",
                  content: "上睑凹陷-双眼皮重塑-上睑下垂矫正-4600-9800元",
                  textAll: "上睑下垂矫正-4600-9800元",
                  checked: false,
                  money: 9800
                },
                {
                  id: 78,
                  name: "美化-翘睫",
                  text: "<span>2000</span>元",
                  content: "上睑凹陷-双眼皮重塑-美化-翘睫-2000元",
                  textAll: "美化-翘睫-2000元",
                  checked: false,
                  money: 2000
                },
                {
                  id: 79,
                  name: "美化-外眦开大",
                  text: "<span>4800</span>元",
                  content: "上睑凹陷-双眼皮重塑-美化-外眦开大-4800元",
                  textAll: "美化-外眦开大-4800元",
                  checked: false,
                  money: 4800
                },
                {
                  id: 80,
                  name: "美化-下睑下至",
                  text: "<span>4800</span>元",
                  content: "上睑凹陷-双眼皮重塑-美化-下睑下至-4800元",
                  textAll: "美化-下睑下至-4800元",
                  checked: false,
                  money: 4800
                }
              ]
            },
            {
              id: 81,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico4.png",
              title: "填充",
              cont: [
                {
                  id: 82,
                  name: "普通脂肪",
                  text: "特价<span>3800</span>元",
                  content: "上睑凹陷-填充-脂肪填充-普通脂肪-特价3800元",
                  textAll: "普通脂肪-特价3800元",
                  checked: false,
                  money: 3800
                },
                {
                  id: 83,
                  name: "纳米脂肪",
                  text: "特价<span>5000</span>元",
                  content: "上睑凹陷-填充-脂肪填充-纳米脂肪-特价5000元",
                  textAll: "纳米脂肪-特价5000元",
                  checked: false,
                  money: 5000
                },
                {
                  id: 84,
                  name: "效果提升(a活能营养)",
                  text: "特价<span>2000</span>元",
                  content:
                    "上睑凹陷-填充-脂肪填充-效果提升(a活能营养)-特价2000元",
                  textAll: "效果提升(a活能营养)-特价2000元",
                  checked: false,
                  money: 2000
                },
                {
                  id: 85,
                  name: "熊猫针",
                  text: "特价<span>4200</span>元",
                  content: "上睑凹陷-填充-玻尿酸填充-熊猫针-特价4200元",
                  textAll: "熊猫针-特价4200元",
                  checked: false,
                  money: 4200
                },
                {
                  id: 86,
                  name: "肤丽美",
                  text: "<span>10800</span>元",
                  content: "上睑凹陷-填充-胶原蛋白填充-肤丽美-10800元",
                  textAll: "肤丽美-10800元",
                  checked: false,
                  money: 10800
                }
              ]
            }
          ]
        },

        {
          id: 7,
          project_name: "眉弓",
          child: [
            {
              id: 87,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico4.png",
              title: "脂肪填充",
              cont: [
                {
                  id: 88,
                  name: "普通脂肪",
                  text: "特价<span>3000</span>元",
                  content: "眉弓-脂肪填充-普通脂肪-特价3000元",
                  textAll: "普通脂肪-特价3000元",
                  checked: false,
                  money: 3000
                },
                {
                  id: 89,
                  name: "纳米脂肪",
                  text: "特价<span>5000</span>元",
                  content: "眉弓-脂肪填充-纳米脂肪-特价5000元",
                  textAll: "纳米脂肪-特价5000元",
                  checked: false,
                  money: 5000
                },
                {
                  id: 90,
                  name: "效果提升(a活能营养)",
                  text: "特价<span>2000</span>元",
                  content: "眉弓-脂肪填充-效果提升(a活能营养)-特价2000元",
                  textAll: "效果提升(a活能营养)-特价2000元",
                  checked: false,
                  money: 2000
                }
              ]
            },
            {
              id: 91,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico4.png",
              title: "玻尿酸填充",
              cont: [
                {
                  id: 92,
                  name: "熊猫针",
                  text: "特价<span>4200</span>元",
                  content: "眉弓-玻尿酸填充-熊猫针-特价4200元",
                  textAll: "熊猫针-特价4200元",
                  checked: false,
                  money: 4200
                }
              ]
            },
            {
              id: 93,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico4.png",
              title: "胶原蛋白填充",
              cont: [
                {
                  id: 94,
                  name: "肤丽美",
                  text: "<span>10800</span>元",
                  content: "眉弓-胶原蛋白填充-肤丽美-10800元",
                  textAll: "肤丽美-10800元",
                  checked: false,
                  money: 10800
                }
              ]
            }
          ]
        },

        {
          id: 8,
          project_name: "下睑退缩",
          child: [
            {
              id: 95,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico18.png",
              title: "下睑退缩",
              cont: [
                {
                  id: 96,
                  name: "下睑退缩矫正术",
                  text: "<span>4800</span>元",
                  content: "下睑退缩-下睑退缩矫正术-4800元",
                  textAll: "下睑退缩矫正术-4800元",
                  checked: false,
                  money: 4800
                }
              ]
            }
          ]
        },

        {
          id: 9,
          project_name: "下睑动态纹",
          child: [
            {
              id: 97,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico15.png",
              title: "动态纹",
              cont: [
                {
                  id: 98,
                  name: "进口除皱针",
                  text: "特价<span>1000</span>元",
                  content: "下睑动态纹-进口除皱针-特价1000元",
                  textAll: "进口除皱针-特价1000元",
                  checked: false,
                  money: 1000
                },
                {
                  id: 99,
                  name: "ACR除皱",
                  text: "特价<span>1800</span>元",
                  content: "下睑动态纹-ACR除皱-特价1800元",
                  textAll: "ACR除皱-特价1800元",
                  checked: false,
                  money: 1800
                }
              ]
            }
          ]
        },
        {
          id: 10,
          project_name: "下睑干纹",
          child: [
            {
              id: 100,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico16.png",
              title: "中胚层",
              cont: [
                {
                  id: 101,
                  name: "丝丽532",
                  text: "特价<span>1980</span>元",
                  content: "下睑干纹-中胚层-丝丽532-特价1980元",
                  textAll: "丝丽532-特价1980元",
                  checked: false,
                  money: 1980
                },
                {
                  id: 102,
                  name: "三文鱼",
                  text: "特价<span>1980</span>元",
                  content: "下睑干纹-中胚层-三文鱼-特价1980元",
                  textAll: "三文鱼-特价1980元",
                  checked: false,
                  money: 1980
                },
                {
                  id: 103,
                  name: "菲洛嘉",
                  text: "特价<span>2800</span>元",
                  content: "下睑干纹-中胚层-菲洛嘉-特价2800元",
                  textAll: "菲洛嘉-特价2800元",
                  checked: false,
                  money: 2800
                },
                {
                  id: 104,
                  name: "氐珠",
                  text: "特价<span>3800</span>元",
                  content: "下睑干纹-中胚层-氐珠-特价3800元",
                  textAll: "氐珠-特价3800元",
                  checked: false,
                  money: 3800
                },
                {
                  id: 105,
                  name: "ACR除皱",
                  text: "特价<span>1800</span>/元",
                  content: "下睑干纹-中胚层-ACR除皱-特价1800/元",
                  textAll: "ACR除皱-特价1800/元",
                  checked: false,
                  money: 1800
                }
              ]
            },
            {
              id: 106,
              ico: "",
              title: "",
              cont: [
                {
                  id: 107,
                  name: "ACR除皱",
                  text: "特价<span>1800</span>元",
                  content: "下睑干纹-ACR除皱-特价1800元",
                  textAll: "ACR除皱-特价1800元",
                  checked: false,
                  money: 1800
                }
              ]
            }
          ]
        },
        {
          id: 11,
          project_name: "下睑真性皱纹",
          child: [
            {
              id: 108,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico17.png",
              title: "胶原蛋白填充",
              cont: [
                {
                  id: 109,
                  name: "双美",
                  text: "<span>10800</span>/支",
                  content: "下睑真性皱纹-胶原蛋白填充-双美-特价10800/支",
                  textAll: "双美-特价10800/支",
                  checked: false,
                  money: 10800
                },
                {
                  id: 110,
                  name: "薇旖美",
                  text: "<span>20400</span>/3支",
                  content: "下睑真性皱纹-胶原蛋白填充-薇旖美-20400/3支",
                  textAll: "薇旖美-20400/3支",
                  checked: false,
                  money: 20400
                }
              ]
            },
            {
              id: 111,
              ico: "",
              title: "",
              cont: [
                {
                  id: 112,
                  name: "眼周固定收紧",
                  text: "<span>8800</span>元",
                  content: "下睑真性皱纹-眼周固定收紧-8800元",
                  textAll: "眼周固定收紧-8800元",
                  checked: false,
                  money: 8800
                }
              ]
            },
            {
              id: 113,
              ico: "",
              title: "",
              cont: [
                {
                  id: 114,
                  name: "成纤维皮膜修复",
                  text: "<span>76800</span>/3次",
                  content: "下睑真性皱纹-成纤维皮膜修复-76800/3次",
                  textAll: "成纤维皮膜修复-76800/3次",
                  checked: false,
                  money: 76800
                }
              ]
            },
            {
              id: 115,
              ico: "",
              title: "",
              cont: [
                {
                  id: 116,
                  name: "ACR除皱",
                  text: "<span>1800</span>元",
                  content: "下睑真性皱纹-ACR除皱-1800元",
                  textAll: "ACR除皱-1800元",
                  checked: false,
                  money: 1800
                }
              ]
            }
          ]
        },

        {
          id: 12,
          project_name: "鱼尾纹",
          child: [
            {
              id: 118,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico1.png",
              title: "轻度-动态纹",
              cont: [
                {
                  id: 119,
                  name: "除皱针",
                  text: "<span>1000</span>元",
                  content: "鱼尾纹-轻度动态纹-除皱针-1000元",
                  textAll: "除皱针-1000元",
                  checked: false,
                  money: 1000
                },
                {
                  id: 120,
                  name: "ACR除皱",
                  text: "<span>1800</span>元",
                  content: "鱼尾纹-轻度动态纹-ACR除皱-1800元",
                  textAll: "ACR除皱-1800元",
                  checked: false,
                  money: 1800
                }
              ]
            },
            {
              id: 121,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico1.png",
              title: "重度-静态纹",
              cont: [
                {
                  id: 122,
                  name: "ACR除皱",
                  text: "<span>1800</span>元",
                  content: "鱼尾纹-重度静态纹-ACR除皱-1800元",
                  textAll: "ACR除皱-1800元",
                  checked: false,
                  money: 1800
                },
                {
                  id: 123,
                  name: "胶原蛋白",
                  text: "<span>20400</span>/3支",
                  content: "鱼尾纹-重度静态纹-胶原蛋白-20400/3支",
                  textAll: "胶原蛋白-20400/3支",
                  checked: false,
                  money: 20400
                },
                {
                  id: 124,
                  name: "皮膜修复",
                  text: "<span>76800</span>/3支",
                  content: "鱼尾纹-重度静态纹-皮膜修复-76800/3支",
                  textAll: "皮膜修复-76800/3支",
                  checked: false,
                  money: 76800
                },
                {
                  id: 125,
                  name: "纳米脂肪填充",
                  text: "<span>5000</span>元",
                  content: "鱼尾纹-重度静态纹-纳米脂肪填充-5000元",
                  textAll: "纳米脂肪填充-5000元",
                  checked: false,
                  money: 5000
                }
              ]
            }
          ]
        },

        {
          id: 13,
          project_name: "泪沟",
          child: [
            {
              id: 126,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico7.png",
              title: "泪沟",
              cont: [
                {
                  id: 127,
                  name: "熊猫针",
                  text: "<span>3800</span>/支",
                  content: "泪沟-熊猫针-3800/支",
                  textAll: "熊猫针-3800/支",
                  checked: false,
                  money: 3800
                },
                {
                  id: 128,
                  name: "纳米脂肪",
                  text: "<span>5800</span>/次",
                  content: "泪沟-纳米脂肪-5800/次",
                  textAll: "纳米脂肪-5800/次",
                  checked: false,
                  money: 5800
                }
              ]
            }
          ]
        },

        {
          id: 14,
          project_name: "眼袋-单一脂肪型",
          child: [
            {
              id: 129,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico8.png",
              title: "单一脂肪型",
              cont: [
                {
                  id: 130,
                  name: "内入法(经结膜入路)",
                  text: "特价<span>2800</span>元",
                  content:
                    "眼袋单一脂肪型-单一脂肪型-内入法(经结膜入路)-特价2800元",
                  textAll: "内入法(经结膜入路)-特价2800元",
                  checked: false,
                  money: 2800
                }
              ]
            }
          ]
        },
        {
          id: 15,
          project_name: "眼袋-复合型",
          child: [
            {
              id: 131,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico9.png",
              title: "脂肪+皮肤松弛型",
              cont: [
                {
                  id: 132,
                  name: "眼袋切除(经皮肤入路)",
                  text: "特价<span>4800</span>元",
                  content:
                    "眼袋复合型-(脂肪+皮肤松弛型)-眼袋切除(经皮肤入路)-特价4800元",
                  textAll: "眼袋切除(经皮肤入路)-特价4800元",
                  checked: false,
                  money: 4800
                },
                {
                  id: 133,
                  name: "眶隔加固",
                  text: "特价<span>3000</span>元",
                  content: "眼袋复合型-(脂肪+皮肤松弛型)-眶隔加固-特价3000元",
                  textAll: "眶隔加固-特价3000元",
                  checked: false,
                  money: 3000
                }
              ]
            },
            {
              id: 134,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico10.png",
              title: "脂肪+松弛+泪沟",
              cont: [
                {
                  id: 135,
                  name: "眼袋切除",
                  text: "特价<span>4800</span>元",
                  content: "眼袋复合型-(脂肪+松弛+泪沟)-眼袋切除-特价4800元",
                  textAll: "眼袋切除-特价4800元",
                  checked: false,
                  money: 4800
                },
                {
                  id: 136,
                  name: "眶隔加固",
                  text: "特价<span>3000</span>元",
                  content: "眼袋复合型-(脂肪+松弛+泪沟)-眶隔加固-特价3000元",
                  textAll: "眶隔加固-特价3000元",
                  checked: false,
                  money: 3000
                },
                {
                  id: 137,
                  name: "泪沟填充(脂肪转移)",
                  text: "特价<span>3000</span>元",
                  content:
                    "眼袋复合型-(脂肪+松弛+泪沟)-泪沟填充(脂肪转移)-特价3000元",
                  textAll: "泪沟填充(脂肪转移)-特价3000元",
                  checked: false,
                  money: 3000
                }
              ]
            },
            {
              id: 138,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico11.png",
              title: "脂肪+松弛+泪沟+苹果肌下垂",
              cont: [
                {
                  id: 139,
                  name: "眼袋切除",
                  text: "特价<span>4800</span>元",
                  content:
                    "眼袋复合型-(脂肪+松弛+泪沟+苹果肌下垂)-眼袋切除-特价4800元",
                  textAll: "眼袋切除-特价4800元",
                  checked: false,
                  money: 4800
                },
                {
                  id: 140,
                  name: "眶隔加固",
                  text: "特价<span>3000</span>元",
                  content:
                    "眼袋复合型-(脂肪+松弛+泪沟+苹果肌下垂)-眶隔加固-特价3000元",
                  textAll: "眶隔加固-特价3000元",
                  checked: false,
                  money: 3000
                },
                {
                  id: 141,
                  name: "泪沟填充",
                  text: "特价<span>3000</span>元",
                  content:
                    "眼袋复合型-(脂肪+松弛+泪沟+苹果肌下垂)-泪沟填充-特价3000元",
                  textAll: "泪沟填充-特价3000元",
                  checked: false,
                  money: 3000
                },
                {
                  id: 142,
                  name: "中面部提升",
                  text: "特价<span>15800</span>元",
                  content:
                    "眼袋复合型-(脂肪+松弛+泪沟+苹果肌下垂)-中面部提升-特价15800元",
                  textAll: "中面部提升-特价15800元",
                  checked: false,
                  money: 15800
                }
              ]
            }
          ]
        },

        {
          id: 16,
          project_name: "黑眼圈",
          child: [
            {
              id: 143,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico1.png",
              title: "仪器治疗",
              cont: [
                {
                  id: 144,
                  name: "超皮秒",
                  text: "<span>800</span>/元",
                  content: "黑眼圈-仪器治疗-超皮秒-800元",
                  textAll: "超皮秒-800元",
                  checked: false,
                  money: 800
                },
                {
                  id: 145,
                  name: "FOTONA",
                  text: "<span>1800</span>/元",
                  content: "黑眼圈-仪器治疗-FOTONA-1800元",
                  textAll: "FOTONA-1800元",
                  checked: false,
                  money: 1800
                }
              ]
            },
            {
              id: 146,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico14.png",
              title: "注射类",
              cont: [
                {
                  id: 147,
                  name: "耀白小灯泡",
                  text: "特价<span>2380</span>元",
                  content: "黑眼圈-注射类-耀白小灯泡-特价2380元",
                  textAll: "耀白小灯泡-特价2380元",
                  checked: false,
                  money: 2380
                },
                {
                  id: 148,
                  name: "熊猫针",
                  text: "特价<span>3800</span>元",
                  content: "黑眼圈-注射类-熊猫针-特价3800元",
                  textAll: "熊猫针-特价3800元",
                  checked: false,
                  money: 3800
                }
              ]
            }
          ]
        },
        {
          id: 17,
          project_name: "其他(眼部护理)",
          child: [
            {
              id: 149,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico12.png",
              title: "眼膜",
              xilie: [
                {
                  id: 150,
                  name: "华熙生物系列",
                  cont: [
                    {
                      id: 151,
                      name: "XXX",
                      text: "<span>00000</span>元",
                      content: "其他(眼部护理)-眼膜-华熙生物系列-xxx-00000元",
                      textAll: "华熙生物系列-xxx-00000元",
                      checked: false,
                      money: 0
                    }
                  ]
                },
                {
                  id: 152,
                  name: "修丽可系列",
                  cont: [
                    {
                      id: 153,
                      name: "XXX",
                      text: "<span>00000</span>元",
                      content: "其他(眼部护理)-眼膜-修丽可系列-xxx-00000元",
                      textAll: "修丽可系列-xxx-00000元",
                      checked: false,
                      money: 0
                    }
                  ]
                },
                {
                  id: 154,
                  name: "菲洛嘉系列",
                  cont: [
                    {
                      id: 155,
                      name: "XXX",
                      text: "<span>00000</span>元",
                      content: "其他(眼部护理)-眼膜-菲洛嘉系列-xxx-00000元",
                      textAll: "菲洛嘉系列-xxx-00000元",
                      checked: false,
                      money: 0
                    }
                  ]
                }
              ]
            },
            {
              id: 156,
              ico:
                "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_ico13.png",
              title: "眼霜",
              xilie: [
                {
                  id: 157,
                  name: "华熙生物系列",
                  cont: [
                    {
                      id: 158,
                      name: "米蓓尔",
                      text: "特价<span>00000</span>元",
                      content:
                        "其他(眼部护理)-眼霜-华熙生物系列-米蓓尔-特价00000元",
                      textAll: "华熙生物系列-米蓓尔-00000元",
                      checked: false,
                      money: 0
                    },
                    {
                      id: 159,
                      name: "润百颜",
                      text: "特价<span>00000</span>元",
                      content:
                        "其他(眼部护理)-眼霜-华熙生物系列-润百颜-特价00000元",
                      textAll: "华熙生物系列-润百颜-00000元",
                      checked: false,
                      money: 0
                    },
                    {
                      id: 160,
                      name: "夸迪",
                      text: "特价<span>00000</span>元",
                      content:
                        "其他(眼部护理)-眼霜-华熙生物系列-夸迪-特价00000元",
                      textAll: "华熙生物系列-夸迪-00000元",
                      checked: false,
                      money: 0
                    }
                  ]
                },
                {
                  id: 161,
                  name: "修丽可系列",
                  cont: [
                    {
                      id: 162,
                      name: "XXX",
                      text: "<span>00000</span>元",
                      content: "其他(眼部护理)-眼霜-修丽可系列-xxx-00000元",
                      textAll: "修丽可系列-xxx-00000元",
                      checked: false,
                      money: 0
                    }
                  ]
                },
                {
                  id: 163,
                  name: "菲洛嘉系列",
                  cont: [
                    {
                      id: 164,
                      name: "XXX",
                      text: "<span>00000</span>元",
                      content: "其他(眼部护理)-眼霜-菲洛嘉系列-xxx-00000元",
                      textAll: "菲洛嘉系列-xxx-00000元",
                      checked: false,
                      money: 0
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      navShow: false,
      activeNames: "",
      activeName: "",
      navList: [
        {
          title: "眼部护理",
          child: [
            {
              title: "中胚层护理",
              id: 0
            },
            {
              title: "仪器护理",
              id: 1
            },
            {
              title: "居家护理",
              id: 2
            }
          ]
        },
        {
          title: "上睑",
          child: [
            {
              title: "松弛下垂",
              child: [
                {
                  title: "轻度",
                  id: 3
                },
                {
                  title: "中度",
                  id: 4
                },
                {
                  title: "重度",
                  id: 5
                }
              ]
            },
            {
              title: "凹陷",
              id: 6
            }
          ]
        },
        {
          title: "眉弓",
          id: 7
        },
        {
          title: "下睑退缩",
          id: 8
        },
        {
          title: "下睑纹",
          child: [
            {
              title: "动态纹",
              id: 9
            },
            {
              title: "干纹",
              id: 10
            },
            {
              title: "真性皱纹",
              id: 11
            }
          ]
        },
        {
          title: "鱼尾纹",
          id: 12
        },
        {
          title: "泪沟",
          id: 13
        },
        {
          title: "眼袋",
          child: [
            {
              title: "单一脂肪型",
              id: 14
            },
            {
              title: "复合型",
              id: 15
            }
          ]
        },
        {
          title: "黑眼圈",
          id: 16
        },
        {
          title: "其他",
          id: 17
        }
      ],
      saveData1: []
    };
  },
  created() {
    vm = this;
    vm.saveData1 = cookie.get(SAVEDATA) ? cookie.get(SAVEDATA) : [];
    console.log(vm.saveData1);
  },
  watch: {},
  mounted: function() {
    this.urlId = this.$route.query.id;
    if (this.urlId == 2 || this.urlId == 17) {
      this.logo =
        "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/logo3.png";
    } else {
      this.logo =
        "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/logo.png";
    }

    this.init();
  },
  computed: {},
  methods: {
    init() {
      console.log("CHUSHIHUA");
      var ids = [];
      for (var m = 0; m < vm.saveData1.length; m++) {
        ids.push(vm.saveData1[m].id1);
      }
      for (var i = 0; i < vm.projectList.length; i++) {
        if (vm.projectList[i].id == vm.urlId) {
          vm.datainfo = vm.projectList[i];
          for (var i1 = 0; i1 < vm.datainfo.child.length; i1++) {
            if (vm.urlId == 17 || vm.urlId == 2) {
              console.log("非");
              for (var ym = 0; ym < vm.datainfo.child[i1].xilie.length; ym++) {
                for (
                  var xm = 0;
                  xm < vm.datainfo.child[i1].xilie[ym].cont.length;
                  xm++
                ) {
                  if (
                    ids.indexOf(vm.datainfo.child[i1].xilie[ym].cont[xm].id) !=
                    -1
                  ) {
                    vm.datainfo.child[i1].xilie[ym].cont[xm].checked = true;
                  }
                }
              }
            } else {
              console.log("真");
              for (var y = 0; y < vm.datainfo.child[i1].cont.length; y++) {
                if (ids.indexOf(vm.datainfo.child[i1].cont[y].id) != -1) {
                  vm.datainfo.child[i1].cont[y].checked = true;
                }
              }
            }
          }
        }
      }
    },
    chooseAck(cont, mainCont, middleCont, index, index0, index1) {
      if (middleCont == "") {
        //表示用户点击的是常规布局的数据
        console.log("表示用户点击的是常规布局的数据");
        if (cont.checked == false) {
          this.datainfo.child[index0].cont[index].checked = true;
          this.saveData1.push({
            id: this.datainfo.child[index0].id,
            id1: this.datainfo.child[index0].cont[index].id,
            id2: 0,
            content: cont.content,
            money: cont.money
          });
        } else {
          this.datainfo.child[index0].cont[index].checked = false;
          for (var i = 0; i < this.saveData1.length; i++) {
            if (
              this.saveData1[i].id1 ==
              this.datainfo.child[index0].cont[index].id
            ) {
              this.saveData1.splice(i, 1);
            }
          }
        }
      } else {
        console.log("表示用户点击的是非/常规布局的数据");
        if (cont.checked == false) {
          this.datainfo.child[index0].xilie[index1].cont[index].checked = true;
          this.saveData1.push({
            id: this.datainfo.child[index0].id,
            id1: this.datainfo.child[index0].xilie[index1].cont[index].id,
            id2: this.datainfo.child[index0].xilie[index1].id,
            content: cont.content,
            money: cont.money
          });
        } else {
          this.datainfo.child[index0].xilie[index1].cont[index].checked = false;
          for (var i = 0; i < this.saveData1.length; i++) {
            if (
              this.saveData1[i].id1 ==
              this.datainfo.child[index0].xilie[index1].cont[index].id
            ) {
              this.saveData1.splice(i, 1);
            }
          }
        }
      }
      console.log(" this.saveData1:", this.saveData1);
      cookie.set(SAVEDATA, this.saveData1);

      // this.subInfoDialog = true;
      // this.userContent = cont.textAll;
      // this.subText = cont.content;
    },
    goallSub() {
      window.location.href = "/mianzheng/subinfo";
    },
    hideSubDialog() {
      this.subInfoDialog = false;
    },
    goPage(id) {
      console.log(id);
      this.$router.replace({
        path: "/mianzheng/info",
        query: {
          id: id
        }
      });
      this.urlId = this.$route.query.id;
      if (this.urlId == 2 || this.urlId == 17) {
        this.logo =
          "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/logo3.png";
      } else {
        this.logo =
          "https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/logo.png";
      }

      this.init();
      this.navShow = false;
    },
    yesSubinfo() {
      if (this.userName.trim().length < 1) {
        return Toast("请务必输入用户姓名！");
      } else if (
        !/^(([0-9]|[1-9][1-9]|1[0-7][0-9])(\\.[0-9]+)?|180)$/.test(this.userAge)
      ) {
        return Toast("请务必正确输入用户年龄！");
      }
      var data = {
        user_name: this.userName,
        sex: this.pickedSex,
        age: this.userAge,
        brand_key: "a28Xjl4VovNS59Du",
        content: this.subText
      };
      getAddConsultation(data)
        .then(res => {
          Toast(res.msg);
          this.subInfoDialog = false;
          // setTimeout(function() {
          //   window.location.href = "/my";
          // }, 1200);
        })
        .catch(err => {
          Toast("提交失败！");
        });
    }
  }
};
</script>
<style scoped>
@font-face {
  font-family: "pingfangscbold";
  src: url("/assets/iconfont.pingFangSCBold.ttf");
  font-weight: norm;
  font-style: norm;
}
img {
  display: block;
  width: 100%;
}

.info {
  width: 100%;
  position: relative;
  min-height: 100vh;
  background: url(https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/bgimg1.png)
    no-repeat;
  background-size: cover;
  background-position: 0;
}

.logo1 {
  left: 0.2rem;
  bottom: 1.4rem;
  display: block;
  width: 2.56rem;
}

.logo {
  height: 1rem;
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  background: #540186;
  z-index: 99;
}

.main {
  margin: 0 auto;
  width: 100%;
  left: 0;
}

.mode_project {
  margin: 0.48rem auto;
}

.mode {
  background: rgba(255, 255, 255, 0.15);
  border: 0.02rem solid rgba(255, 255, 255, 0.15);
  width: calc(100% - 0.28rem - 0.32rem);
  margin-left: 0.28rem;
  margin-bottom: 0.26rem;
  border-radius: 0.16rem;
  padding-bottom: 0.53rem;
}

.name {
  display: flex;
  width: 100%;
  align-items: center;
  position: relative;
  color: #fff;
  font-size: 0.36rem;
  padding: 0.38rem 0 0 0.24rem;
}

.name img {
  display: block;
  width: 0.8rem;
  margin-right: 0.1rem;
}

.item_view {
  width: calc(100% - 0.24rem - 0.15rem);
  margin-left: 0.24rem;
  background: #481583;
  border-radius: 0.4rem;
  color: #fff;
  display: flex;
  position: relative;
  justify-content: space-between;
  margin: 0.36rem auto 0;
  font-size: 0.28rem;
  align-items: center;
  position: relative;
  line-height: 0.44rem;
}

.item_view2 {
  width: calc(100% - 0.24rem - 0.15rem);
  margin-left: 0.24rem;
  border-radius: 0.4rem;
  color: #fff;
  display: flex;
  position: relative;
  justify-content: space-between;
  font-size: 0.28rem;
  align-items: center;
  position: relative;
  line-height: 0.44rem;
  padding: 0 0.15rem;
  margin: 0.1rem auto 0;
}

.item_view2::before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  width: 45%;
  height: 100%;
  background: rgba(82, 12, 149, 0.6);
  border-radius: 0.2rem 0.8rem 0 0.2rem;
  bottom: 0;
}

.item_view2::after {
  content: "";
  display: block;
  position: absolute;
  right: 0;
  width: 62%;
  height: 80%;
  background: rgba(82, 12, 149, 0.6);
  border-radius: 0 0.2rem 0.2rem 0;
  bottom: 0;
}

.xlTitle {
  height: 0.8rem;
  line-height: 0.8rem;
  font-size: 0.34rem;
  -webkit-text-stroke: 0.01rem #fff;
  position: relative;
  z-index: 2;
}

.xlli {
  position: relative;
}

.item_view2::after {
  content: "";
  display: block;
  position: absolute;
  right: 0;
}

.xielieC {
  width: 100%;
}

.xl_li {
  background: #481583;
  display: block;
  border-radius: 0.5em;
  position: relative;
  z-index: 2;
  margin-bottom: 0.3rem;
}

.childName {
  color: #481583;
  width: 3rem;
  text-align: center;
  border-radius: 0.4rem;
  background: #fff;
  display: inline-block;
  font-size: 0.26rem;
  align-items: center;
  line-height: 0.5rem;
  font-family: "pingfangscbold";
}

.textHtml {
  width: calc(100% - 3rem);
  text-align: right;
  padding-right: 0.5rem;
  font-size: 0.23rem;
  position: absolute;
  right: 0;
  bottom: 0;
  align-items: baseline;
  justify-content: flex-end;
}

.checkedImg {
  position: absolute;
  right: 0.2rem;
  display: block;
  width: 0.2rem;
  top: 50%;
  transform: translateY(-50%);
}

.dialog_mz {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
}

.mianzheng_main {
  width: 6.8rem;
  background-color: #fff;
  border-radius: 0.16rem;
  padding: 0.3rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.mz_Title {
  text-align: center;
  font-size: 0.36rem;
  color: #000;
  padding: 0 0 0.4rem;
}

.closeBtn {
  position: absolute;
  right: 0.3rem;
  top: 0.2rem;
  display: block;
  width: 0.4rem;
}

.inputText {
  width: 100%;
  display: flex;
  position: relative;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 0.02rem solid #f0f0f0;
}

.inputText span {
  display: block;
  width: 1.6rem;
  text-align: left;
  font-size: 0.28rem;
  color: #333;
}

.inputText > input {
  display: block;
  width: calc(100% - 1.6rem);
  color: #666;
  font-size: 0.28rem;
  height: 1rem;
}

.sex {
  display: flex;
  width: calc(100% - 1.6rem);
  color: #333;
  font-size: 0.28rem;
  height: 1rem;
  align-items: center;
}

.contentInputText {
  color: #000 !important;
}

.checkInput {
  background: url(https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_w1.png)
    no-repeat;
  -webkit-appearance: none;
  background-size: cover;
  background-position: center;
  width: 30px;
  height: 30px;
}

.checkedInput {
  background: url(https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/yz_w2.png)
    no-repeat;
  -webkit-appearance: none;
  background-size: cover;
  background-position: center;
  width: 30px;
  height: 30px;
}

.sex label {
  margin: 0 1rem 0 0.2rem;
}

.yesSubinfo {
  position: relative;
  width: 100%;
  line-height: 0.8rem;
  color: #fff;
  text-align: center;
  background-color: #520c95;
  border-radius: 0.16rem;
  margin: 0.4rem auto 0.2rem;
}

.nav_btn {
  position: absolute;
  right: 0.28rem;
}

.nav_box {
  overflow: hidden;
}

.nav_header {
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 0;
  background: #540186;
}

.nav_content {
  height: calc(100% - 1rem);
  overflow: auto;
}

.item_cell {
  padding-left: 0;
  padding-right: 0;
}

.title {
  line-height: 0.8rem;
}

.submit_btn {
  position: fixed;
  left: 78%;
  transform: translateX(-50%);
  width: 3rem;
  bottom: 0rem;
  z-index: 1994;
}
</style>

<style>
.van-collapse-item__content {
  padding-top: 0;
  padding-bottom: 0;
}

.textHtml span {
  font-size: 0.5rem;
  font-style: italic;
  padding: 0 0.05rem 0 0.05rem;
}
</style>
